import styled from "styled-components";
// 비교표 한 줄: [기존 방식] [구분] [에이원 방식]
const CompareTableRow = ({ contents: { div, content1, content2 } }) => {
  return (
    <Div $cols={(content1 ? 1 : 0) + (content2 ? 1 : 0)}>
      {content1 && <ContentDiv className="before">{content1}</ContentDiv>}
      <DivDiv>{div}</DivDiv>
      {content2 && <ContentDiv className="after">{content2}</ContentDiv>}
    </Div>
  );
};
export default CompareTableRow;
const Div = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ $cols }) =>
    $cols === 2 ? "minmax(0, 1fr) auto minmax(0, 1fr)" : "auto minmax(0, 1fr)"};
  align-items: center;
  gap: 1.5rem;
  padding: 1.1rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & > div:last-child {
    text-align: ${({ $cols }) => ($cols === 2 ? "center" : "left")};
  }
  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.5rem;
    text-align: center;
  }
`;
const ContentDiv = styled.div`
  font-size: clamp(0.95rem, 1.4vw, 1.1rem);
  line-height: 1.6;
  text-align: center;
  color: ${({ theme }) => theme.colors.monotone.dark};
  @media (max-width: 767px) {
    &.before {
      order: 2;
    }
    &.after {
      order: 3;
    }
  }
`;
const DivDiv = styled.div`
  justify-self: center;
  min-width: 8.5rem;
  padding: 0.6rem 1.1rem;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.dark};
  color: white;
  font-weight: 700;
  text-align: center;
  @media (max-width: 767px) {
    order: 1;
  }
`;
